import { Grid, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

import useRoles from 'common/hooks/useRoles';

import NewGuarantorButton from './NewGuarantorButton';
import PatientGuarantorsTable from './PatientGuarantorsTable';

const PatientGuarantorsTab = () => {
  const { mpi } = useParams();
  const hasAccess = useRoles();

  return (
    <Grid container direction='column' spacing={2} sx={{ mt: 2 }}>
      <Grid item container justifyContent='space-between'>
        <Typography variant='h6' component='h2'>
          Guarantors
        </Typography>
        {hasAccess.addGuarantor && <NewGuarantorButton mpi={mpi} />}
      </Grid>

      <Grid item>
        <PatientGuarantorsTable mpi={mpi} />
      </Grid>
    </Grid>
  );
};

export default PatientGuarantorsTab;
